module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kh-Lb.5d9b1de8.png";